var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.blockClassName},[_c('div',{class:_vm.childrenClassName('stickyWrapper')},[_c('molecules-navigations-topbar',{attrs:{"hide-humburger":true}})],1),_c('div',{class:_vm.childrenClassName('content')},[_c('router-view',{attrs:{"config":_vm.config}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }